import React, { Component } from 'react';

import './styles/modalMilleniumPool.scss';

export default class ModalMilleniumPool extends Component {
  render() {
    return (
      <div className="millenium-pool-banner">
        <img className="desktop" src={require('../../../static/images/millenium-pool.jpg')} alt=""/>
        <img className="mobile" src={require('../../../static/images/millenium-pool-mobile.jpg')} alt=""/>
      </div>
    )
  }
}